export enum mobileDeepLink {
  tribaldatadev = 'tribaldatadev',
  tribaldatauat = 'tribaldatauat',
  tribaldataprod = 'tribaldata'
}
